(() => {
  'use strict';

  const FOOTER_OFFSET = 16;
  const FOOTER_SELECTORS = '.wim-footer, .winery-footer';

  const getFab = () => document.querySelector('.winery-whatsapp');

  const getFooterAnchorTop = () => {
    let minTop = Infinity;

    for (const footer of document.querySelectorAll(FOOTER_SELECTORS)) {
      const rect = footer.getBoundingClientRect();
      if (rect.height === 0) continue;
      if (rect.top < window.innerHeight) {
        minTop = Math.min(minTop, rect.top);
      }
    }

    return minTop;
  };

  const update = () => {
    const fab = getFab();
    if (!fab) return;

    const anchorTop = getFooterAnchorTop();

    if (anchorTop === Infinity) {
      fab.style.removeProperty('--winery-whatsapp-bottom');
      return;
    }

    const bottom = window.innerHeight - anchorTop + FOOTER_OFFSET;
    fab.style.setProperty('--winery-whatsapp-bottom', `${bottom}px`);
  };

  const init = () => {
    const fab = getFab();
    if (!fab) return;

    let ticking = false;
    const schedule = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(schedule);
      for (const footer of document.querySelectorAll(FOOTER_SELECTORS)) {
        observer.observe(footer);
      }
    }

    schedule();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
